var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 231.67 64.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f26f21;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #174592;\n      }\n\n      .cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .cls-5 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 26.44;\n        stroke-width: 11.64px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path5691",
    className: "cls-4",
    d: "M101.44,27.35h5.2c3.97,0,7.43-1.01,7.43-5.2,0-2.74-1.87-4.47-4.52-4.69v-.06c2.46-.62,4.02-1.96,4.02-4.64,0-3.6-2.79-4.92-6.84-4.92h-5.28V27.35Zm2.79-8.88h1.82c2.4,0,5.06,.42,5.06,3.44,0,2.63-2.26,3.16-4.78,3.16h-2.09v-6.59Zm0-8.33h2.93c1.62,0,3.6,.59,3.6,2.91,0,2.88-2.29,3.13-5,3.13h-1.54v-6.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5695",
    className: "cls-4",
    d: "M129.35,24.13c-.64,.53-2.65,1.42-4.39,1.42-2.49,0-4.69-1.93-4.69-4.75h10.17c0-4.58-1.54-8.05-6.29-8.05-4.02,0-6.68,2.99-6.68,7.21,0,4.64,2.32,7.71,7.37,7.71,2.35,0,3.49-.56,4.5-.92v-2.63Zm-9.08-5.28c.2-1.84,1.26-3.97,3.83-3.97,2.26,0,3.55,1.79,3.55,3.97h-7.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5699",
    className: "cls-3",
    d: "M133.95,27.35h2.63v-6.48c0-3.58,1.54-5.81,3.88-5.81,.45,0,.98,.06,1.45,.25v-2.35c-.56-.11-.95-.2-1.73-.2-1.51,0-3.02,1.06-3.72,2.54h-.06v-2.21h-2.46v14.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5701",
    className: "cls-3",
    d: "M147.78,27.35V6.39h-2.63V27.35h2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5705",
    className: "cls-4",
    d: "M152.91,13.1v14.25h2.63V13.1h-2.63Zm2.79-3.18v-2.96h-2.96v2.96h2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5709",
    className: "cls-3",
    d: "M160.34,27.35h2.63v-6.59c0-3.46,1.34-5.87,4.33-5.87,2.29,.14,3.02,1.76,3.02,5.08v7.38h2.63v-8.46c0-3.83-1.65-6.12-5.34-6.12-1.98,0-3.88,.98-4.67,2.6h-.06v-2.26h-2.54v14.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5713",
    className: "cls-4",
    d: "M188.33,24.13c-.64,.53-2.65,1.42-4.39,1.42-2.49,0-4.69-1.93-4.69-4.75h10.17c0-4.58-1.54-8.05-6.29-8.05-4.02,0-6.68,2.99-6.68,7.21,0,4.64,2.32,7.71,7.37,7.71,2.35,0,3.49-.56,4.5-.92v-2.63Zm-9.08-5.28c.19-1.84,1.26-3.97,3.83-3.97,2.26,0,3.55,1.79,3.55,3.97h-7.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5717",
    className: "cls-3",
    d: "M192.94,27.35h2.63v-6.48c0-3.58,1.54-5.81,3.88-5.81,.45,0,.98,.06,1.45,.25v-2.35c-.56-.11-.95-.2-1.73-.2-1.51,0-3.02,1.06-3.71,2.54h-.06v-2.21h-2.46v14.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5721",
    className: "cls-3",
    d: "M116.98,37.37h-2.93l-6.17,17.04h-.06l-6.01-17.04h-3.13l7.35,19.5h3.49l7.46-19.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5725",
    className: "cls-4",
    d: "M117.07,49.75c0,4.08,2.96,7.46,7.26,7.46s7.24-3.38,7.24-7.46c0-4.33-2.91-7.46-7.24-7.46s-7.26,3.13-7.26,7.46Zm2.79,0c0-2.71,1.65-5.34,4.47-5.34s4.44,2.63,4.44,5.34c0,2.54-1.37,5.34-4.44,5.34s-4.47-2.79-4.47-5.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5727",
    className: "cls-3",
    d: "M138.04,56.87v-20.95h-2.63v20.95h2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5731",
    className: "cls-3",
    d: "M142.84,56.87h2.63v-7.32l6.37,7.32h3.77l-7.46-7.93,6.62-6.31h-3.58l-5.73,5.78v-12.49h-2.63v20.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5735",
    className: "cls-3",
    d: "M157.17,56.42c1.2,.64,2.57,.78,3.91,.78,2.54,0,4.97-1.4,4.97-4.44,0-4.55-6.17-3.71-6.17-6.62,0-1.17,1.17-1.73,2.51-1.73,.61,0,2.18,.36,2.77,.73l.22-2.29c-1.03-.31-2.04-.56-3.27-.56-2.82,0-5.03,1.42-5.03,4.39,0,4,6.17,3.77,6.17,6.37,0,1.53-1.48,2.04-2.68,2.04-.75,0-2.24-.34-3.27-1.01l-.14,2.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5739",
    className: "cls-4",
    d: "M169.24,56.87h2.51v-2.01h.06c.7,1.06,2.32,2.35,4.86,2.35,4.3,0,6.12-3.8,6.12-7.71s-2.01-7.21-6.15-7.21c-2.49,0-3.91,.98-4.72,2.29h-.06v-8.66h-2.63v20.95Zm10.76-7.18c.06,2.24-1.12,5.39-3.94,5.39-2.96,0-4.19-2.93-4.19-5.31,0-2.66,1.37-5.36,4.22-5.36s3.97,2.71,3.91,5.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5743",
    className: "cls-4",
    d: "M187.11,45.87c1.06-.89,2.65-1.45,4.14-1.45,2.62,0,3.52,1.26,3.52,3.72-1.03-.06-1.76-.06-2.79-.06-2.71,0-6.62,1.12-6.62,4.69,0,3.1,2.15,4.44,5.22,4.44,2.4,0,3.8-1.31,4.41-2.18h.06v1.84h2.46c-.06-.42-.11-1.17-.11-2.79v-5.9c0-3.88-1.65-5.89-5.73-5.89-1.82,0-3.38,.56-4.69,1.34l.14,2.24Zm7.66,5.48c0,2.12-1.37,3.74-3.97,3.74-1.2,0-2.65-.81-2.65-2.32,0-2.51,3.52-2.74,4.94-2.74,.56,0,1.12,.06,1.68,.06v1.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5747",
    className: "cls-3",
    d: "M201.83,56.87h2.63v-6.59c0-3.46,1.34-5.87,4.33-5.87,2.29,.14,3.02,1.76,3.02,5.08v7.38h2.63v-8.46c0-3.83-1.65-6.12-5.34-6.12-1.98,0-3.88,.98-4.67,2.6h-.06v-2.26h-2.54v14.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5751",
    className: "cls-3",
    d: "M218.9,56.87h2.63v-7.32l6.37,7.32h3.77l-7.46-7.93,6.62-6.31h-3.58l-5.73,5.78v-12.49h-2.63v20.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5755",
    className: "cls-5",
    d: "M5.82,58.3V5.82H82.48V58.3H5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5761",
    className: "cls-2",
    d: "M81.86,57.7V6.54H6.34V57.7H81.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5765",
    className: "cls-1",
    d: "M81.86,57.7v-8.97h-28.79c-.79,4.12-1.45,7.61-1.71,8.97h30.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5769",
    className: "cls-1",
    d: "M6.34,48.74v8.97h30.28l-2.02-8.97H6.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5773",
    className: "cls-3",
    d: "M21.22,27.42l-2.2-9.28h18.8l6.09,26.63h.26l3.84-17.06c1.93-7.75,2.66-9.57,13.56-9.57h7.84s-1.58,7.14-3.55,14.89c-.75,2.96-7.29,2.6-6.97-.15,.03-.29,.34-2.36,.59-3.84,.36-2.13-2.12-2.39-2.57-.29-.32,1.51-1.76,8.99-3.1,16.03h28.07V6.54H6.34V44.78h27.41l-3.9-17.34h-8.63"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.41f7442751e0cf38acc72c40ebdad6a5.svg";
export { ForwardRef as ReactComponent };